(() => {

    //***** about *****
    new setParallax('.sc-about__header .img-wrap', '.sc-about__header .img-box', '-10%', '10%');

    //about list에 있는 이미지 전부 parallax
    const aboutBodyWrap = document.querySelectorAll('.sc-about__body .img-wrap');
    const aboutBodyBox = document.querySelectorAll('.sc-about__body .img-box');
    new setParallax(aboutBodyWrap[0], aboutBodyBox[0], '-5%', '5%');
    new setParallax(aboutBodyWrap[1], aboutBodyBox[1], '-10%', '10%');
    new setParallax(aboutBodyWrap[2], aboutBodyBox[2], '-15%', '15%');
    new setParallax(aboutBodyWrap[3], aboutBodyBox[3], '-13%', '13%');
    new setParallax(aboutBodyWrap[4], aboutBodyBox[4], '-5%', '5%');

    //***** outro *****
    new setParallax('.sc-outro .img-wrap', '.sc-outro .img-box', '-15%', '15%');
})();
